export enum FeedType {
  HOME = "home",
  MY_PREDICTIONS = "my_predictions",
  MY_QUESTIONS_AND_POSTS = "my_questions_and_posts",
  WEEKLY_TOP_COMMENTS = "weekly_top_comments",
  FOLLOWING = "following",
  IN_REVIEW = "in_review",
  COMMUNITIES = "communities",
}

export const POST_PAGE_FILTER = "page";
export const POST_TOPIC_FILTER = "topic";
export const POST_TEXT_SEARCH_FILTER = "search";
export const POST_TYPE_FILTER = "forecast_type";
export const POST_STATUS_FILTER = "status";
export const POST_CATEGORIES_FILTER = "categories";
export const POST_LEADERBOARD_TAGS_FILTER = "leaderboard_tags";
export const POST_FORECASTER_ID_FILTER = "forecaster_id";
export const POST_WITHDRAWN_FILTER = "withdrawn";
export const POST_NOT_FORECASTER_ID_FILTER = "not_forecaster_id";
export const POST_FOLLOWING_FILTER = "following";
export const POST_FOR_MAIN_FEED = "for_main_feed";
export const POST_AUTHOR_FILTER = "author";
export const POST_USERNAMES_FILTER = "usernames";
export const POST_UPVOTED_BY_FILTER = "upvoted_by";
export const POST_COMMENTED_BY_FILTER = "commented_by";
export const POST_ACCESS_FILTER = "access";
export const POST_ORDER_BY_FILTER = "order_by";
export const POST_NEWS_TYPE_FILTER = "news_type";
export const POST_COMMUNITIES_FILTER = "communities";
export const POST_WEEKLY_TOP_COMMENTS_FILTER = "weekly_top_comments";
export const POST_PROJECT_FILTER = "default_project_id";

export const POSTS_PER_PAGE = 10;
